export const STARTING_MAZE = [
    '###############',
    '#S....#....o.E#',
    '#.###.#.###.#.#',
    '#.....#.....#.#',
    '###.#.###.#.#.#',
    '#o..#.....#...#',
    '#.#####.#####.#',
    '#.............#',
    '###############',
];
export function parseMaze(rows = STARTING_MAZE) {
    const height = rows.length;
    const width = rows[0].length;
    let start = { x: 1, y: 1 };
    let exit = { x: width - 2, y: 1 };
    const tiles = [];
    for (let y = 0; y < height; y++) {
        for (let x = 0; x < width; x++) {
            let t = rows[y][x];
            if (t === 'S') {
                start = { x, y };
                t = ' ';
            }
            if (t === 'E') {
                exit = { x, y };
                t = 'E';
            }
            tiles.push(t);
        }
    }
    return { width, height, tiles, start, exit };
}
export function idx(x, y, width) { return y * width + x; }
export function tileAt(tiles, width, x, y) { return tiles[idx(x, y, width)] ?? '#'; }
export function isWall(t) { return t === '#'; }
